import {
  Box,
  Button,
  Radio,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import {
  assetIds,
  EVENT_TYPES,
  IconWithCircle,
  ThemedAsset,
} from "nemuru-components";
import React, { useContext, useEffect } from "react";
import { useForm } from "react-hook-form";
import { ICON_TITLE_HEIGHT } from "../../../../../../config/config";
import IconTitle from "../../../../../shared/components/IconTitle";
import InfoPanel from "../../../../../shared/components/InfoPanel";
import MainButton from "../../../../../shared/components/MainButton";
import { devConsoleLog } from "../../../../../../utils/devConsoleLog";
import { KYC_AUTOMATIC_OPTINS_TYPES_LIST } from "../config";
import { ProcessContext } from "../../../../../../contexts/ProcessContext";
import OptinsManager from "../../../../../shared/components/OptinsManager";
import { OptInsPatchCheckMapper } from "../../../../../../utils/mappers/OptInsPatchMappers";
import {
  checkInitialStateForDisableAcceptButton,
  getModuleOptIns,
  isAnyOptInInNullState,
} from "../../../../../../utils/optInsHelpers";
import { useEventDispatcher } from "../../../../../../utils/hooks/useEventDispatcher";
import { removeObjectFromArrayByKeyAndValue } from "../../../../../../utils/removeObjectFromArray";
import ElectronicIdError from "../components/ElectronicIdError";
import ElectronicIdWidget from "../components/ElectronicIdWidget";
import Text from "../../../../../shared/components/Text";
import {
  docIdTypes,
  documentTypes,
  infoDataDocumentType,
} from "../../../shared/config";

import { findDocumentByParticipantDocumentType } from "../constants/findDocumentByParticipantDocumentType";
import { useTranslation } from "../../../../../../utils/hooks/useTranslation";

export default function KycElectronicID({
  onSubmitForm,
  onKoStep,
  disableKycManual,
  allowInternationalBorrower,
  contextMessage,
}) {
  const { palette, customBorderRadius } = useTheme();
  const { handleSubmit, getValues, errors, register, control, setValue } =
    useForm();

  const {
    state: { loan, optIns, currentModuleObject, participant },
    dispatch,
  } = useContext(ProcessContext);

  const { dispatchEvent } = useEventDispatcher();

  const participantDocumentType =
    participant.onboardingDetails?.user_details?.document_id?.document_type;

  const [state, setState] = React.useState({
    success: false,
    error: false,
    errorResponse: undefined,
    openWidget: false,
    selectedDocumentType: participantDocumentType
      ? findDocumentByParticipantDocumentType(participantDocumentType)[0]
          .display
      : documentTypes[0].display,
    optInsState: [],
    disableAcceptButton: false,
    postOptIns: false,
    optInsStateIsSet: false,
  });

  const {
    error,
    errorResponse,
    openWidget,
    selectedDocumentType,
    optInsState,
    disableAcceptButton,
    postOptIns,
    optInsStateIsSet,
  } = state;

  const isPassportSelected =
    selectedDocumentType.props.tId === docIdTypes.PASSPORT;

  useEffect(() => {
    checkWhichOptinsBelongToModuleAndSetState();
  }, [optIns]);

  useEffect(() => {
    optInsState.length !== 0 && areRequiredOptInsChecked();
  }, [optInsState]);

  useEffect(() => {
    optInsStateIsSet &&
      setState((s) => ({
        ...s,
        disableAcceptButton:
          checkInitialStateForDisableAcceptButton(optInsState),
      }));
  }, [optInsStateIsSet]);

  useEffect(() => {
    setState((s) => ({
      ...s,
      disableAcceptButton: isPassportSelected
        ? false
        : isAnyOptInInNullState(getValues()),
    }));
  }, [selectedDocumentType]);

  const checkIfOptInsShallBePosted = (optIns) => {
    var postOptinsFlagArray = [];
    optIns.map((optin) => {
      if (optin.required && !optin.checked) {
        postOptinsFlagArray.push(true);
      } else {
        postOptinsFlagArray.push(false);
      }
    });
    const shallOptInsPostBePosted = postOptinsFlagArray.includes(true);
    setState((s) => ({
      ...s,
      postOptIns: shallOptInsPostBePosted,
    }));
  };

  const selectDocumentType = (name) => {
    setState((s) => ({ ...s, selectedDocumentType: name }));
  };

  const checkWhichOptinsBelongToModuleAndSetState = () => {
    const optInConditionsTempArray = getModuleOptIns(
      KYC_AUTOMATIC_OPTINS_TYPES_LIST,
      optIns
    );
    setState((s) => ({
      ...s,
      optInsState: optInConditionsTempArray,
      optInsStateIsSet: true,
    }));
  };

  const areRequiredOptInsChecked = () => {
    optInsState && !postOptIns && checkIfOptInsShallBePosted(optInsState);
    var disableButtonArray = [];
    optInsState?.map((optin) => {
      if (optin.required && !optin.checked) {
        disableButtonArray.push(true);
      } else {
        disableButtonArray.push(false);
      }
    });
    const shallButtonBeDisabled = disableButtonArray.includes(true);
    setState((s) => ({
      ...s,
      disableButton: shallButtonBeDisabled,
    }));
  };

  const handleChange = (name, value) => {
    setValue(name, value);
    setState((s) => ({
      ...s,
      disableAcceptButton: isAnyOptInInNullState(getValues()),
    }));
  };

  const onStartIdentification = () => {
    if (isPassportSelected) {
      dispatch({
        type: "UPDATE_PROCESS_CONTEXT",
        payload: { documentType: docIdTypes.PASSPORT },
      });
      dispatch({
        type: "SET_MODULE_KO",
      });
      return;
    }
    openWidgetDialogAndPostOptIns(getValues());
  };

  const openWidgetDialogAndPostOptIns = (formValuesObject) => {
    const screenPath = `${currentModuleObject?.id}.ELECTRONIC_ID_WIDGET`;
    dispatchEvent({
      name: screenPath,
      type: EVENT_TYPES.progress,
      payload: {
        module: currentModuleObject?.id,
        screenPath: screenPath,
      },
    });
    setState((s) => ({ ...s, openWidget: true }));
    if (postOptIns) {
      var conditions_check = [];
      Object.keys(formValuesObject).map((value) => {
        optInsState.map((optin) => {
          optin.name === value &&
            conditions_check.push({
              id: optin.condition_id,
              check: formValuesObject[value],
            });
        });
      });
      const dataToSend = OptInsPatchCheckMapper.hydrate({
        id: optIns.id,
        conditions_check,
        loanId: loan.id,
        borrowerId: participant.participantId,
      });
      dispatch({
        type: "REQUEST_PATCH_OPTIN_BY_ID_CONDITIONS_CHECK_IN_AND_SEQUENCE",
        payload: dataToSend,
      });
    }
  };

  const onRetry = () => {
    setState((s) => ({
      ...s,
      openWidget: true,
      error: false,
      errorResponse: undefined,
    }));
  };

  const onSuccess = (video) => {
    devConsoleLog("ElectronicId response - SUCCESS");
    setState((s) => ({
      ...s,
      success: true,
      openWidget: false,
    }));
    onSubmitForm({
      requestId: video.id,
      selectedDocumentType: selectedDocumentType,
    });
  };

  const onError = (videoId, error) => {
    videoId.destroy();
    dispatch({
      type: "UPDATE_PROCESS_CONTEXT",
      payload: { kycAuthorization: undefined, videoId: undefined },
    });
    setState((s) => ({
      ...s,
      error: true,
      errorResponse: error,
      openWidget: false,
    }));
  };

  const documentTypeSelectionArray = participantDocumentType
    ? findDocumentByParticipantDocumentType(participantDocumentType)
    : allowInternationalBorrower
    ? documentTypes
    : removeObjectFromArrayByKeyAndValue(
        documentTypes,
        "id",
        docIdTypes.PASSPORT
      );

  return (
    <>
      {!openWidget && (
        <>
          <InfoPanel infoData={infoDataDocumentType} />
          <Box>
            <IconTitle
              icon={
                <ThemedAsset
                  id={assetIds.ICON_ID_VIDEO}
                  width={ICON_TITLE_HEIGHT}
                  height={ICON_TITLE_HEIGHT}
                  style={{ color: palette.secondary.main }}
                />
              }
              title={<Text tId="VIDEO_ID" />}
              subtitle={<Text tId="SELECT_DOCUMENT_TYPE" />}
            />
            {!error && (
              <>
                {contextMessage ? (
                  <Box my={2} className="fade-in">
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      align="center"
                    >
                      {contextMessage}
                    </Typography>
                  </Box>
                ) : (
                  <Box style={{ height: "5vh" }} className="fade-in" />
                )}
                <Box
                  px={2}
                  py={1}
                  bgcolor={palette.grey[100]}
                  borderRadius={customBorderRadius.paper}
                  textAlign="left"
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                >
                  {documentTypeSelectionArray?.map((docType) => (
                    <DocumentType
                      key={docType.id}
                      name={docType.display}
                      selected={selectedDocumentType === docType.display}
                      selectDocumentType={selectDocumentType}
                    />
                  ))}
                </Box>
              </>
            )}
          </Box>
          {!error && (
            <Box mt={3}>
              {!isPassportSelected && (
                <OptinsManager
                  optInsState={optInsState}
                  handleChange={handleChange}
                  errors={errors}
                  register={register}
                  control={control}
                />
              )}
              {isPassportSelected && (
                <Typography variant={"caption"} color={"textPrimary"}>
                  <Text tId={"NO_ELECTRONIC_ID_FOR_PASSPORT_MESSAGE"} />
                </Typography>
              )}
              <MainButton
                disabled={disableAcceptButton}
                onClick={handleSubmit(onStartIdentification)}
              >
                <Text tId="START_ID" />
              </MainButton>
            </Box>
          )}
          {error && (
            <>
              <Box px={4}>
                <ElectronicIdError errorResponse={errorResponse} />
              </Box>
              <Box mb={2}>
                <Box mt={4}>
                  <Button
                    className="progression"
                    style={{ width: "100%", height: 48 }}
                    variant="contained"
                    color="primary"
                    onClick={onRetry}
                  >
                    <Text tId="RETRY" />
                  </Button>
                </Box>
                {disableKycManual !== true && (
                  <Box mt={2}>
                    <Button
                      className="progression"
                      style={{ width: "100%", height: 48 }}
                      variant="contained"
                      color="secondary"
                      onClick={() =>
                        onKoStep({ selectedDocumentType: selectedDocumentType })
                      }
                    >
                      <Text tId="MANUAL_IDENTIFICATION" />
                    </Button>
                  </Box>
                )}
              </Box>
            </>
          )}
        </>
      )}
      {openWidget && (
        <>
          <ElectronicIdWidget
            selectedDocumentType={selectedDocumentType}
            onSuccess={onSuccess}
            onError={onError}
          />
        </>
      )}
    </>
  );
}

const DocumentType = ({ name, selectDocumentType, selected = false }) => {
  const { palette, spacing, breakpoints } = useTheme();
  const isScreenXs = useMediaQuery(breakpoints.down("xs"));
  const { getTextIdTranslation } = useTranslation();

  return (
    <Box
      my={1}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      onClick={() => selectDocumentType(name)}
      style={{ height: spacing(3), cursor: "pointer" }}
    >
      <Typography
        color={selected ? "textPrimary" : "textSecondary"}
        variant={isScreenXs ? "subtitle2" : "subtitle1"}
      >
        <strong>{name}</strong>
      </Typography>
      {selected ? (
        <IconWithCircle
          backgroundColor={palette.primary.main}
          height={spacing(3)}
          width={spacing(3)}
          className="material-icons"
          style={{
            fontSize: spacing(2),
            color: palette.primary.contrastText,
          }}
        >
          check
        </IconWithCircle>
      ) : (
        <Radio
          inputProps={{
            "aria-label": getTextIdTranslation(
              `${name?.props?.tId}_ARIA_LABEL`
            ),
          }}
          style={{
            padding: 0,
            margin: "0.25rem",
            background: palette.grey[50],
            height: "16px",
            width: "16px",
          }}
          size="medium"
        />
      )}
    </Box>
  );
};
